import { Component, OnInit, Input } from '@angular/core';
import { VstsBuild } from '../../models/build-health-models';

@Component({
  selector: 'app-build-history',
  templateUrl: './build-history.component.html',
  styleUrls: ['./build-history.component.css']
})
export class BuildHistoryComponent implements OnInit {

  @Input() buildHistory: VstsBuild[];

  constructor() { }

  ngOnInit() {
  }

  openLinkInNewTab(link: string): void {
    window.open(link, '_blank');
  }

  tooltipInfo(build: VstsBuild) {
    if (build.id > 0) {
      let extra = build.status;
      if (build.result) {
        extra += ` / ${build.result}`;
      }
      let tip = `Open build ${build.buildNumber} requested by ${build.requestedFor.displayName} (${extra})`;
      return tip;
    } 
  }
}